import { store } from './store';
import { actions } from '@iso/redux/auth/reducer';

export default () =>
  new Promise(() => {
    store.dispatch(actions.checkAuthorization());
  });
